/* SK Productos Recomendados - Carga via API de recomendaciones + slider */
(function () {
  'use strict';

  /* Inicializa el slider de arrastrar/wheel (igual que sk-products.js) */
  function initSlider(slider) {
    if (slider.getAttribute('data-slider-init')) return;
    slider.setAttribute('data-slider-init', 'true');

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var didDrag = false;

    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      /* No iniciar drag al pulsar una flecha de la mini-galeria */
      if (e.target.closest('.sk-products__img-arrow')) return;
      isDown = true;
      didDrag = false;
      slider.classList.add('sk-products__slider--grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('sk-products__slider--grabbing');
    });

    slider.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('sk-products__slider--grabbing');
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      didDrag = true;
      var x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });

    slider.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    /* Mini-galeria: pasar las imagenes de la card con las flechas */
    slider.addEventListener('click', function (e) {
      var arrow = e.target.closest('.sk-products__img-arrow');
      if (!arrow || didDrag) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = arrow.closest('.sk-products__image-wrapper');
      if (!wrapper) return;

      var imgs = wrapper.querySelectorAll('.sk-products__image');
      if (imgs.length < 2) return;

      var current = 0;
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].classList.contains('sk-products__image--active')) { current = i; break; }
      }

      var dir = arrow.classList.contains('sk-products__img-arrow--next') ? 1 : -1;
      var next = (current + dir + imgs.length) % imgs.length;

      imgs[current].classList.remove('sk-products__image--active');
      imgs[next].classList.add('sk-products__image--active');

      /* La flecha izquierda solo aparece si no estamos en la primera imagen */
      var prevBtn = wrapper.querySelector('.sk-products__img-arrow--prev');
      if (prevBtn) prevBtn.classList.toggle('sk-products__img-arrow--hidden', next === 0);
    });

    slider.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0) return;
      if ((e.deltaY < 0 && slider.scrollLeft <= 0) || (e.deltaY > 0 && slider.scrollLeft >= maxScroll - 1)) return;
      e.preventDefault();
      slider.scrollLeft += e.deltaY;
    }, { passive: false });

    /* Anadir al carrito */
    slider.addEventListener('click', function (e) {
      var btn = e.target.closest('.sk-products__action-btn--cart');
      if (!btn || didDrag) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      if (btn.classList.contains('sk-products__action-btn--loading')) return;
      btn.classList.add('sk-products__action-btn--loading');

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          btn.classList.remove('sk-products__action-btn--loading');

          if (data.status) {
            return;
          }

          btn.classList.add('sk-products__action-btn--added');
          setTimeout(function () {
            btn.classList.remove('sk-products__action-btn--added');
          }, 1500);

          var evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: variantId,
              data: { source: 'product-form-component', itemCount: 1 }
            }
          });
          document.dispatchEvent(evt);
        })
        .catch(function () {
          btn.classList.remove('sk-products__action-btn--loading');
        });
    });
  }

  /* Carga las recomendaciones via section rendering API */
  function loadRecommendations(section) {
    /* Modo coleccion o recomendaciones ya cargadas: solo inicializar slider */
    var baseUrl = section.dataset.recoUrl;
    if (!baseUrl || section.dataset.recoPerformed === 'true') {
      var slider = section.querySelector('.sk-products__slider');
      if (slider) initSlider(slider);
      return;
    }

    var productId = section.dataset.recoProductId;
    var sectionId = section.dataset.recoSectionId;
    var limit = section.dataset.recoLimit || 4;
    var intent = section.dataset.recoIntent || 'related';

    if (!productId || !sectionId) return;

    var url = baseUrl + '?product_id=' + productId + '&section_id=' + sectionId + '&limit=' + limit + '&intent=' + intent;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('#sk-products-reco-' + sectionId);

        if (newSection && newSection.innerHTML.trim()) {
          section.innerHTML = newSection.innerHTML;
          section.dataset.recoPerformed = 'true';

          var slider = section.querySelector('.sk-products__slider');
          if (slider) initSlider(slider);
        }
      })
      .catch(function (err) {
        console.error('SK Recomendados: error cargando', err);
      });
  }

  /* Lazy load con IntersectionObserver */
  function initSection(section) {
    if (section.dataset.recoInit) return;
    section.dataset.recoInit = 'true';

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          loadRecommendations(section);
        }
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations(section);
    }
  }

  /* Inicializar secciones existentes */
  var sections = document.querySelectorAll('[data-reco-section-id]');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  /* Reinicializar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-reco-section-id]');
    if (section) {
      section.removeAttribute('data-reco-init');
      initSection(section);
    }
  });
})();
